import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import PropTypes from 'prop-types';
import 'ckeditor5/ckeditor5.css';

const TextEditor = (props) => {
  const { id, value = '', onChange } = props;

  return (
    <div>
      <CKEditor
        id={id}
        data={value}
        editor={ClassicEditor}
        config={{
          toolbar: [
            'undo',
            'redo',
            '|',
            'heading',
            '|',
            'bold',
            'italic',
            '|',
            'blockQuote',
            '|',
            'numberedList',
            'bulletedList',
            'outdent',
            'indent',
          ],
        }}
        onChange={(_, editor) => {
          const data = editor.getData();
          onChange?.(data);
        }}
      />
    </div>
  );
};

TextEditor.propTypes = {
  onChange: PropTypes.func,
  id: PropTypes.string,
  value: PropTypes.any,
};

export default TextEditor;
